// extracted by mini-css-extract-plugin
export default {"tab-content-header":"TabContentHeader_tab-content-header__E23YV","tab-content-header__icon":"TabContentHeader_tab-content-header__icon__Fg+Yn"};